import { OperationStatusType } from 'api/types/entity/operation';
import {
  TypedForm,
  FormErrors as FormErrorsBase,
  ObjectSchema,
  object,
  string,
  selectSchema,
} from 'libs/form';
import { SelectType } from 'types/selectType';

import { OperationAvailableStatusesMap } from '../types';

export interface ChangeStatusFormType {
  reason?: string;
  status: SelectType<OperationStatusType>;
}

export interface ChangeStatusFormSchemaProps {
  availableStatusesMap: Partial<OperationAvailableStatusesMap>;
}

export const getSchema = ({
  availableStatusesMap,
}: ChangeStatusFormSchemaProps): ObjectSchema<ChangeStatusFormType> =>
  object({
    status: selectSchema(Object.values(OperationStatusType))
      .required()
      .default(null),

    reason: string().when('status', {
      is: (s: SelectType<OperationStatusType>) =>
        availableStatusesMap[s?.value]?.isRequiredReason,
      then: (schema) => schema.required().max(200),
    }),
  });

export const { Field, Form, useFormContext, Submit } =
  TypedForm<ChangeStatusFormType>();

export type FormErrors = FormErrorsBase<ChangeStatusFormType>;
